import { render } from "./FacetGroupContainer.vue?vue&type=template&id=a3eda572"
import script from "./FacetGroupContainer.vue?vue&type=script&lang=js"
export * from "./FacetGroupContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__